"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeTitle = void 0;
var attribute_title_component_1 = require("./attribute-title.component");
Object.defineProperty(exports, "AttributeTitle", { enumerable: true, get: function () { return __importDefault(attribute_title_component_1).default; } });
